
export const Indemnity = () => {


    return (
        <>
         <div className="container-fluid">
            <div className="row pb-5 p-2" >

                <div className="col-lg-12 text-center pb-5">
                    <h2 className=" mt-4 fw-bold">Indemnity </h2>
                    <div className="col-8 col-lg-3 mx-auto zoom-in-out-box2 ">
                        <hr />
                    </div>
                </div>

                <div className="col-12 px-lg-5 pb-4" style={{textAlign: 'justify',}}>
                    <p className="px-lg-2">Definition of “Indemnity” is Security against loss or damage. In the insurance context it to place the assured as far as possible in the same financial position as he was before the loss of the subject matter insured. The Assured should neither be placed in the better position by making the gain out of his loss nor in the worst position after the loss.  </p>
                    <p>
                        All insurance contracts are contract of Indemnity, exception to this fundamental rule are Life insurance and Personal Accident insurance contracts. Marine insurance contracts are NOT the “perfect Indemnity” contracts and the principle of Indemnity has been modified by the wording of the Marine Insurance Act 1906 Section 1(Marine insurance defined) as under:
                    </p>
                    <p>
                        <i>  “A contract of marine insurance is a contract whereby the insurer undertakes to indemnify the assured, <b> in manner and to the extent thereby agreed,</b> against marine losses, that is to say, the losses incident to marine adventure.”</i>
                    </p>
                    <p>
                        Hence the value to be insured for the subject matter is decided by the assured and agreed by the Underwriter. Value of the Subject Matter of insurance agreed between the parties is conclusive and cannot be re-opened unless there is element of fraud is involved.
                    </p>
                </div>

                <div className="col-12 px-lg-5">
                    <div className="p-lg-5 p-4 bgservices" style={{textAlign: 'justify',}}>
                    <h5 className="fw-bold pb-3">Case Law: </h5>
                    
                        <p>In Castellain v. Preston (1883)  -11 QBD :52 LJQB 366:49 LT 29:31 WR 557
                            “Every contract of marine, fire insurance is a contract of indemnity and of indemnity only, the meaning of which is that the assured in case of a loss is to receive a full indemnity but is never to receive more. Every rule of Insurance Law is adapted in order to carry out this fundamental rule.”
                        </p>

                    </div>

                </div>

                <div className="col-12 px-lg-5 mt-5">
                    <div style={{ background: 'rgb(247 224 215)', border: '1px solid rgb(245 206 191)' }}>


                        <div className="row ps-lg-5 pt-lg-3 pb-lg-3 p-4" style={{textAlign: 'justify',}}>
                            <div className="col-12 col-lg-8">

                                <p><b> Food for Thought:  </b></p>

                                <p>Other related principles of insurance i.e. Insurable Interest, Subrogation, contribution and Return of Premium are stems from the Fundamental principle of Indemnity.   </p>

                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Does it mean, every Marine insurance policy is Agreed Value policy?
                                </p>
                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Is the “Agreed Value” being conclusive for all types of claims under Marine Policies?
                                </p>
                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Can the “Agreed Value” be re-opened for Marine Cargo claims when there is no element of fraud involved?
                                </p>
                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    What are the type of policies based on value can be issued in Marine Insurance?
                                </p>
                            </div>

                            <div className="col-12 col-lg-4 d-flex align-items-center justify-content-center">
                                <img src="Static/Assets/Img/questionary.png" className="questionery_img mx-auto" alt="" srcset="" />

                            </div>

                        </div>



                    </div>
                </div>

            </div>
            </div>
        </>
    )
}
